import dayjs from "dayjs";

/**
 * Available date format options for user preferences
 */
export type DateFormatOption =
  | "YYYY-MM-DD"
  | "MM/DD/YYYY"
  | "DD/MM/YYYY"
  | "MMM DD, YYYY"
  | "MMM DD";

/**
 * Default date format
 */
export const DEFAULT_DATE_FORMAT: DateFormatOption = "YYYY-MM-DD";

/**
 * Date format display names for UI
 */
export const DATE_FORMAT_LABELS: Record<DateFormatOption, string> = {
  "YYYY-MM-DD": "ISO Format (2025-12-04)",
  "MM/DD/YYYY": "US Format (12/04/2025)",
  "DD/MM/YYYY": "European Format (04/12/2025)",
  "MMM DD, YYYY": "Medium Format (Dec 04, 2025)",
  "MMM DD": "Short Format (Dec 04)",
};

/**
 * All available date format options
 */
export const DATE_FORMAT_OPTIONS: DateFormatOption[] = [
  "YYYY-MM-DD",
  "MM/DD/YYYY",
  "DD/MM/YYYY",
  "MMM DD, YYYY",
  "MMM DD",
];

/**
 * Formats a date string according to the specified format
 * @param dateString - ISO date string (YYYY-MM-DD)
 * @param format - Target format option
 * @returns Formatted date string
 */
export function formatDateString(
  dateString: string,
  format: DateFormatOption = DEFAULT_DATE_FORMAT
): string {
  if (!dateString) return "";
  
  try {
    return dayjs(dateString).format(format);
  } catch (error) {
    console.error("Error formatting date:", error);
    return dateString;
  }
}
